document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
      let swatch = e.target.closest(".product-color-swatches .color-swatch");
      if (!swatch) return;

      let optionID = swatch.previousElementSibling?.value;
      let color = swatch.textContent.trim();
      let variantList = swatch.closest(".product-color-swatches").querySelector(`.color-swatch-list[data-color="${color}"]`);
      let variantID = variantList ? variantList.getAttribute("data-id") : null;

      // console.log("c", color, variantID);

      let productCard = swatch.closest(".horizontal-product-card");
      if (productCard) {
          let inputField = productCard.querySelector('input[name="id"]');
          if (inputField) {
              inputField.value = variantID;
          }
      }
  });
  
  document.body.addEventListener("click", (e) => {
    let main_ATC = e.target.closest('.product [data-block-id="buy_buttons"] button[type="submit"]');
    if(main_ATC) {
      document.documentElement.addEventListener("theme:loading:end", () => {
        console.log("Theme loading has ended!");
        window.location.href = `${Shopify.routes.root}cart`;
      });      
    }
  });

});